import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import cx from 'classnames';
import UpgradeTheme from '@upgrade/themes/themes/upgrade';
import addCssUnit from '../utils/add-css-unit';
import useBoundingClientRect from '../hooks/useBoundingClientRect';
import { SpacerElement } from './styles';

// this Spacer element will copy the height of the `targetRef` + gap
const Spacer = ({
  sourceRef,
  domNode,
  breakpoint = 'sm',
  gap = 'xl'
}) => {
  const theme = useTheme();
  const {
    height
  } = useBoundingClientRect(sourceRef);
  const [node, setNode] = useState();
  useEffect(() => {
    if (typeof document !== 'undefined') {
      setNode(domNode || document.body);
    }
  }, [domNode]);
  if (!node) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(SpacerElement, {
    style: {
      height: addCssUnit(height),
      // using marginTop for the gap because of "CSS margin collapse"
      marginTop: theme.spacing[gap]
    },
    className: cx({
      [`hidden-${breakpoint}`]: breakpoint !== 'none'
    })
  }), node));
};
Spacer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  domNode: PropTypes.object,
  // breakpoint="none" to always display it; "sm" will hide the element when window is larger than the "sm" breakpoint
  breakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'none']),
  gap: PropTypes.oneOf(Object.keys(UpgradeTheme.spacing)),
  sourceRef: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    current: PropTypes.object
  }).isRequired
};
export default Spacer;
//# sourceMappingURL=Spacer.js.map